// extracted by mini-css-extract-plugin
export var searchHeader = "_v-0";
export var searchHeaderDark = "_v-1";